import { isFiniteDecimal } from '@eastcoal/common/utils/decimal'

import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'

export const splitCountValidator: SchemaItem['x-validator'] = {
  required: true,
  validator(value, _, ctx) {
    const splitCount = value.splitCount
    const quantity = ctx.form.values.quantity
    if (splitCount && quantity && !isFiniteDecimal(quantity, splitCount)) {
      return `数量（${quantity}）无法平分至 ${splitCount} 份`
    }
    return null
  }
}
